import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../providers/api";

const initialState = { strategies: [], isLoading: true };

export const getStrategies = createAsyncThunk("get-strategies", async () => {
  const response = await api.strategy.getAll();
  return response?.Data;
});

const strategySlice = createSlice({
  name: "strategy",
  initialState,
  reducers: {
    updateStrategy: (state, action) => {
      if (state.strategies?.length === 0) return;
      const index = state.strategies.findIndex(
        (strategy) => strategy.ID === action.payload?.ID
      );
      if (index !== -1) {
        state.strategies[index] = action.payload;
      } else {
        state.strategies.push(action.payload);
      }
    },
    deleteStrategy: (state, action) => {
      const index = state.strategies.findIndex(
        (strategy) => strategy.ID === action.payload
      );
      if (index !== -1) {
        state.strategies.splice(index, 1);
      }
    },
  },
  extraReducers: {
    [getStrategies.fulfilled]: (state, action) => {
      state.strategies = action.payload;
      state.isLoading = false;
    },
    [getStrategies.pending]: (state) => {
      state.isLoading = true;
    },
    [getStrategies.rejected]: (state) => {
      state.isLoading = false;
    },
  },
});

export const { updateStrategy, deleteStrategy } = strategySlice.actions;

export default strategySlice.reducer;
